import {
    REQUEST_INCENTIVES_PROSES,
    REQUEST_INCENTIVES_PROSES_FAILURE,
    REQUEST_INCENTIVES_PROSES_SUCCESS
} from "../../constant/other/IncentiveConstant";

const initialState = {
    incentiveProcess: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const incentiveProcessReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_INCENTIVES_PROSES:
            return {
                ...state,
                incentiveProcess: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_INCENTIVES_PROSES_SUCCESS:
            return {
                ...state,
                incentiveProcess: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_INCENTIVES_PROSES_FAILURE:
            return {
                ...state,
                incentiveProcess: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
